/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStepDTO } from './abstractStepDTO';
import { FieldTableStep } from './fieldTableStep';

export interface ChangeDataEventStepDTO extends AbstractStepDTO {
    searchFields: Array<FieldTableStep>;
    changeType?: ChangeDataEventStepDTO.ChangeTypeEnum;
    origins?: Array<ChangeDataEventStepDTO.OriginEnum>;
    importEtlIds?: Array<string>;
}
export namespace ChangeDataEventStepDTO {
    export type ChangeTypeEnum = 'UPDATE' | 'DELETE' | 'ADD';
    export const ChangeTypeEnum = {
        UPDATE: 'UPDATE' as ChangeTypeEnum,
        DELETE: 'DELETE' as ChangeTypeEnum,
        ADD: 'ADD' as ChangeTypeEnum
    };
    export type OriginEnum = 'BACKOFFICE' | 'PORTAL' | 'RGPD_ANONYMIZATION' | 'IMPORT_MANUAL' | 'IMPORT_SCHEDULED';
    export const OriginEnum = {
        BACKOFFICE: 'BACKOFFICE' as OriginEnum,
        PORTAL: 'PORTAL' as OriginEnum,
        RGPD_ANONYMIZATION: 'RGPD_ANONYMIZATION' as OriginEnum,
        IMPORT_MANUAL: 'IMPORT_MANUAL' as OriginEnum,
        IMPORT_SCHEDULED: 'IMPORT_SCHEDULED' as OriginEnum
    };
}
